import axios from "axios";

const state = () => ({
  loginErrors: [],
  username: null,
  userToken: null,
  rememberMe: localStorage.getItem("rememberMe") || false,
});

const mutations = {
  SET_USER_TOKEN(state, token) {
    localStorage.setItem("user_token", token);
    state.userToken = token;
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  },
  SET_LOGIN_ERROR(state, message) {
    state.loginErrors = [message];
  },
  SET_USERNAME(state, name) {
    state.username = name;
  },
  SET_REMEMBER_ME(state) {
    localStorage.setItem("rememberMe", true);
    state.rememberMe = true;
  },
  CLEAR_REMEMBER_ME(state) {
    localStorage.removeItem("rememberMe");
    state.rememberMe = false;
  },
  LOGOUT(state) {
    localStorage.removeItem("user_token");
    localStorage.removeItem("rememberMe");
    state.userToken = null;
    axios.defaults.headers.common["Authorization"] = "";
  },
};

const getters = {
  isLoggedIn: (state) => {
    return state.userToken !== null;
  },
  getLoginErrors: (state) => {
    return state.loginErrors;
  },
  getUsername: (state) => {
    return state.username;
  },
  getRememberMe: (state) => {
    return state.rememberMe;
  },
};

const actions = {
  async login({ commit }, data) {
    const url = process.env.VUE_APP_API_URL + "/tm/login";
    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const response = await axios.post(url, data, config);
      commit("SET_USER_TOKEN", response.data.token);
      commit("SET_LOGIN_ERROR", null);
    } catch (error) {
      console.log(error);
      commit(
        "SET_LOGIN_ERROR",
        error.response?.data?.message || "Login failed"
      );
    }
  },
  async logout({ commit }) {
    commit("LOGOUT");
  },
  async getUserToken({ commit }) {
    const token = localStorage.getItem("user_token");
    const url = process.env.VUE_APP_API_URL + "/tm/user";
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    try {
      // check if the token is valid
      const response = await axios.get(url, config);
      commit("SET_USERNAME", response.data.name);
      commit("SET_USER_TOKEN", response.data.token);
    } catch (error) {
      // if the token is invalid, log out
      console.log(error);
      commit("LOGOUT");
      commit("CLEAR_REMEMBER_ME");
    }
  },
  async setRememberMe({ commit }) {
    commit("SET_REMEMBER_ME");
  },
  async clearRememberMe({ commit }) {
    commit("CLEAR_REMEMBER_ME");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
